import { NgModule } from '@angular/core';
import { UserRoutingModule } from '../user/user-routing.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
    DxButtonModule,
    DxCheckBoxModule,
    DxColorBoxModule,
    DxDataGridModule,
    DxDateBoxModule,
    DxDrawerModule,
    DxDropDownBoxModule,
    DxDropDownButtonModule,
    DxListModule,
    DxLoadPanelModule,
    DxLookupModule,
    DxNumberBoxModule,
    DxPopupModule,
    DxProgressBarModule,
    DxSchedulerModule,
    DxScrollViewModule,
    DxSelectBoxModule,
    DxSortableModule,
    DxSwitchModule,
    DxTabPanelModule,
    DxTabsModule,
    DxTagBoxModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxToolbarModule,
    DxTooltipModule,
    DxTreeListModule,
    DxValidatorModule
} from 'devextreme-angular';
import { NgPipesModule } from 'ngx-pipes';
import { TranslateModule } from '@ngx-translate/core';
import { GSModule } from 'src/app/libs/gs.module';
import { ProductsAnalysisComponent } from './analysis/products-analysis.component';
import { ProductsConfigurationComponent } from './configuration/products-configuration.component';
import { ProductsFamiliesAddComponent } from './configuration/products-families/products-families-add/products-families-add.component';
import { ProductsFamiliesEditComponent } from './configuration/products-families/products-families-edit/products-families-edit.component';
import { RatesAddComponent } from './configuration/rates/rates-add/rates-add.component';
import { RatesEditComponent } from './configuration/rates/rates-edit/rates-edit.component';
import { RatesComponent } from './configuration/rates/rates.component';
import { ProductsBomsEditComponent } from './operative/products-boms/products-boms-edit/products-boms-edit.component';
import { ProductsBomsComponent } from './operative/products-boms/products-boms.component';
import { ProductsConsignmentStocksAddComponent } from './operative/products-consignment-stocks/products-consignment-stocks-add/products-consignment-stocks-add.component';
import { ProductsConsignmentStocksEditComponent } from './operative/products-consignment-stocks/products-consignment-stocks-edit/products-consignment-stocks-edit.component';
import { ProductsConsignmentStocksComponent } from './operative/products-consignment-stocks/products-consignment-stocks.component';
import { ProductsAddComponent } from './operative/products-operative-products/products-add/products-add.component';
import { ProductsEditComponent } from './operative/products-operative-products/products-edit/products-edit.component';
import { ProductsOperativeProductsContextualizerComponent } from './operative/products-operative-products/products-operative-products-contextualizer/products-operative-products-contextualizer.component';
import { ProductsOperativeProductsComponent } from './operative/products-operative-products/products-operative-products.component';
import { ProductsPricesComponent } from './operative/products-operative-products/products-prices/products-prices.component';
import { ProductsRoutingsEditComponent } from './operative/products-operative-products/products-routings/products-routings-edit/products-routings-edit.component';
import { ProductsRoutingsComponent } from './operative/products-operative-products/products-routings/products-routings.component';
import { ProductsOperativeComponent } from './operative/products-operative.component';
import { ProductsProcessSheetsEditComponent } from './operative/products-process-sheets/products-process-sheets-edit/products-process-sheets-edit.component';
import { ProductsProcessSheetsComponent } from './operative/products-process-sheets/products-process-sheets.component';
import { ProductsTechnicalFeaturesAddComponent } from './configuration/products-technical-features/products-technical-features-add/products-technical-features-add.component';
import { ProductsTechnicalFeaturesEditComponent } from './configuration/products-technical-features/products-technical-features-edit/products-technical-features-edit.component';
import { ProductsTechnicalFeaturesGroupsAddComponent } from './configuration/products-technical-features-groups/products-technical-features-groups-add/products-technical-features-groups-add.component';
import { ProductWarehouseSeasonalitiesComponent } from './operative/products-operative-products/products-edit/product-warehouse-seasonalities/product-warehouse-seasonalities.component';
import { ProductsRoutingModule } from './products-routing.module';
import { ProductsBatchComponent } from './operative/products-batch/products-batch.component';
import { ProductsBatchEditComponent } from './operative/products-batch/products-batch-edit/products-batch-edit.component';
import { ProductsBatchAddComponent } from './operative/products-batch/products-batch-add/products-batch-add.component';
import { ProductsFamiliesTechnicalFeatureGroupAddComponent } from './configuration/products-families/products-families-edit/products-families-technical-feature-group-add/products-families-technical-feature-group-add.component';
import { ProductsPricesAddComponent } from './operative/products-operative-products/components/products-prices-add/products-prices-add.component';
import { ProductsCostsAddComponent } from './operative/products-operative-products/components/products-costs-add/products-costs-add.component';
import { ProductsFormatsAddComponent } from './operative/products-operative-products/components/products-formats-add/products-formats-add.component';
import { ProductsWarehousesAddComponent } from './operative/products-operative-products/components/products-warehouses-add/products-warehouses-add.component';
import { TechnicalFeaturesAddComponent } from './configuration/products-technical-features-groups/components/technical-features-add/technical-features-add.component';
import { RatesPricesAddComponent } from './configuration/rates/components/rates-prices-add/rates-prices-add.component';
import { ProductTechnicalFeaturesAddComponent } from './operative/products-operative-products/components/product-technical-features-add/product-technical-features-add.component';
import { ProductbatchTechnicalfeatureAddComponent } from './operative/products-batch/components/productbatch-technicalfeature-add/productbatch-technicalfeature-add.component';
import { PricePolicyEditComponent } from './configuration/rates/components/price-policy-edit/price-policy-edit.component';
import { PricePolicyAddComponent } from './configuration/rates/components/price-policy-add/price-policy-add.component';
import { ProductPriceLinesComponent } from './operative/products-operative-products/products-prices/product-price-lines/product-price-lines.component';
import { ProductPriceLinesAddComponent } from './operative/products-operative-products/components/product-price-lines-add/product-price-lines-add.component';
import { FormatsComponent } from './configuration/formats/formats.component';
import { FormatsEditComponent } from './configuration/formats/formats-edit/formats-edit.component';
import { FormatsAddComponent } from './configuration/formats/formats-add/formats-add.component';
import { ProductBatchStatesComponent } from './configuration/product-batch-states/product-batch-states.component';
import { ProductBatchStatesEditComponent } from './configuration/product-batch-states/product-batch-states-edit/product-batch-states-edit.component';
import { ProductBatchStatesAddComponent } from './configuration/product-batch-states/product-batch-states-add/product-batch-states-add.component';
import { BatchTypesComponent } from './configuration/batch-types/batch-types.component';
import { BatchTypesEditComponent } from './configuration/batch-types/batch-types-edit/batch-types-edit.component';
import { BatchTypesAddComponent } from './configuration/batch-types/batch-types-add/batch-types-add.component';
import { CheckpointsComponent } from './operative/checkpoints/checkpoints.component';
import { CheckpointsAddComponent } from './operative/checkpoints/checkpoints-add/checkpoints-add.component';
import { CheckpointsEditComponent } from './operative/checkpoints/checkpoints-edit/checkpoints-edit.component';
import { WorkProceduresComponent } from '../aps/aps-configuration/work-procedures/work-procedures.component';
import { WorkProceduresAddComponent } from '../aps/aps-configuration/work-procedures/work-procedures-add/work-procedures-add.component';
import { WorkProceduresEditComponent } from '../aps/aps-configuration/work-procedures/work-procedures-edit/work-procedures-edit.component';
import { StepsAddComponent } from '../aps/aps-configuration/work-procedures/steps-add/steps-add.component';
import { StepsEditComponent } from '../aps/aps-configuration/work-procedures/steps-edit/steps-edit.component';
import { FamiliesSubscribersAddComponent } from './configuration/products-families/families-subscribers-add/families-subscribers-add.component';
import { ProductSubscribersComponent } from './operative/products-operative-products/components/product-subscribers/product-subscribers.component';
import { ProductSubscribersAddComponent } from './operative/products-operative-products/components/product-subscribers/product-subscribers-add/product-subscribers-add.component';
import { ProductFeaturesComponent } from './operative/products-operative-products/components/product-features/product-features.component';
import { ProductCostsComponent } from './operative/products-operative-products/components/product-costs/product-costs.component';
import { ProductPricePurchaseComponent } from './operative/products-operative-products/components/product-price-purchase/product-price-purchase.component';
import { ProductWarehousesComponent } from './operative/products-operative-products/components/product-warehouses/product-warehouses.component';
import { ProductPricesComponent } from './operative/products-operative-products/components/product-prices/product-prices.component';
import { ProductStockComponent } from './operative/products-operative-products/components/product-stock/product-stock.component';
import { ProductLocatedStockComponent } from './operative/products-operative-products/components/product-located-stock/product-located-stock.component';
import { ProductSeasonalitiesComponent } from './operative/products-operative-products/components/product-seasonalities/product-seasonalities.component';
import { ProductDocumentPendingBatchComponent } from './operative/products-operative-products/components/product-document-pending-batch/product-document-pending-batch.component';
import { ProductBatchTechnicalFeaturesComponent } from './operative/products-batch/products-batch-edit/components/product-batch-technical-features/product-batch-technical-features.component';
import { ProductBatchExpensesComponent } from './operative/products-batch/products-batch-edit/components/product-batch-expenses/product-batch-expenses.component';
import { ProductBatchMovementsComponent } from './operative/products-batch/products-batch-edit/components/product-batch-movements/product-batch-movements.component';
import { ProductsProcessSheetsAddComponent } from './operative/products-process-sheets/products-process-sheets-add/products-process-sheets-add.component';
import { ProcessSheetsProductAddComponent } from './operative/products-process-sheets/products-process-sheets-edit/process-sheets-product-add/process-sheets-product-add.component';
import { ProcessSheetOperationsComponent } from './operative/products-process-sheets/products-process-sheets-edit/components/process-sheet-operations/process-sheet-operations.component';
import { RoutingAddComponent } from './operative/products-process-sheets/products-process-sheets-edit/components/routing-add/routing-add.component';
import { RoutingOperationsAddComponent } from './operative/products-process-sheets/products-process-sheets-edit/components/process-sheet-operations/components/routing-operations-add/routing-operations-add.component';
import { RoutingOperationsEditComponent } from './operative/products-process-sheets/products-process-sheets-edit/components/process-sheet-operations/components/routing-operations-edit/routing-operations-edit.component';
import { ResourceAllocationAddComponent } from './operative/products-process-sheets/products-process-sheets-edit/components/process-sheet-operations/components/resource-allocation-add/resource-allocation-add.component';
import { ProcessSheetMaterialsComponent } from './operative/products-process-sheets/products-process-sheets-edit/components/process-sheet-materials/process-sheet-materials.component';
import { ProcessSheetOverheadsComponent } from './operative/products-process-sheets/products-process-sheets-edit/components/process-sheet-overheads/process-sheet-overheads.component';
import { ProcessSheetOverheadsAddComponent } from './operative/products-process-sheets/products-process-sheets-edit/components/process-sheet-overheads/process-sheet-overheads-add/process-sheet-overheads-add.component';
import { ProcessSheetsBomAddComponent } from './operative/products-process-sheets/products-process-sheets-edit/components/process-sheet-materials/components/process-sheets-boom-add/process-sheets-bom-add.component';
import { WorkProcedureEditComponent } from './operative/products-process-sheets/products-process-sheets-edit/components/process-sheet-operations/components/work-procedure-edit/work-procedure-edit.component';
import { ProductProcesSheetsComponent } from './operative/products-operative-products/product-proces-sheets/product-proces-sheets.component';
import { ProcessSheetMaterialsAddComponent } from './operative/products-process-sheets/products-process-sheets-edit/components/process-sheet-materials/components/process-sheet-materials-add/process-sheet-materials-add.component';
import { ProductSimulationsComponent } from './operative/products-operative-products/product-simulations/product-simulations.component';
import { SimulationsComponent } from './operative/products-process-sheets/components/simulations/simulations.component';
import { ProcessSheetLinksComponent } from './operative/products-process-sheets/products-process-sheets-edit/components/process-sheet-links/process-sheet-links.component';
import { QRCodeComponent } from 'angularx-qrcode';
import { WorkProcedureLinksComponent } from '../aps/aps-configuration/work-procedures/work-procedures-edit/components/work-procedure-links/work-procedure-links.component';
import { ProductMapComponent } from './operative/products-operative-products/components/product-map/product-map.component';
import { ProductAncestorsDescendantsComponent } from './operative/products-process-sheets/components/product-ancestors-descendants/product-ancestors-descendants.component';
import {
  ProductProcessSheetAddComponent
} from './operative/products-operative-products/product-proces-sheets/product-process-sheets-add/product-process-sheets-add.component';
import {GsPopupComponent} from "../../libs/components/gs-popup/gs-popup.component";


@NgModule({
    declarations: [
        ProductsAnalysisComponent,
        ProductProcessSheetAddComponent,
        ProductsConfigurationComponent,
        ProductsFamiliesEditComponent,
        ProductsFamiliesAddComponent,
        ProductsOperativeComponent,
        ProductsOperativeProductsComponent,
        ProductsAddComponent,
        ProductsEditComponent,
        ProductWarehouseSeasonalitiesComponent,
        RatesComponent,
        RatesAddComponent,
        RatesEditComponent,
        ProductsPricesComponent,
        ProductsBomsComponent,
        ProductsBomsEditComponent,
        ProductsRoutingsComponent,
        ProductsRoutingsEditComponent,
        ProductsProcessSheetsComponent,
        ProductsProcessSheetsEditComponent,
        ProductsOperativeProductsContextualizerComponent,
        ProductsConsignmentStocksComponent,
        ProductsConsignmentStocksAddComponent,
        ProductsConsignmentStocksEditComponent,
        ProductsTechnicalFeaturesAddComponent,
        ProductsTechnicalFeaturesEditComponent,
        ProductsTechnicalFeaturesGroupsAddComponent,
        ProductsBatchComponent,
        ProductsBatchEditComponent,
        ProductsBatchAddComponent,
        ProductsFamiliesTechnicalFeatureGroupAddComponent,
        ProductsPricesAddComponent,
        ProductsCostsAddComponent,
        ProductsFormatsAddComponent,
        ProductsWarehousesAddComponent,
        TechnicalFeaturesAddComponent,
        RatesPricesAddComponent,
        ProductTechnicalFeaturesAddComponent,
        ProductbatchTechnicalfeatureAddComponent,
        PricePolicyEditComponent,
        PricePolicyAddComponent,
        ProductPriceLinesComponent,
        ProductPriceLinesAddComponent,
        FormatsComponent,
        FormatsEditComponent,
        FormatsAddComponent,
        ProductBatchStatesComponent,
        ProductBatchStatesEditComponent,
        ProductBatchStatesAddComponent,
        BatchTypesComponent,
        BatchTypesEditComponent,
        BatchTypesAddComponent,
        CheckpointsComponent,
        CheckpointsAddComponent,
        CheckpointsEditComponent,
        WorkProceduresComponent,
        WorkProceduresAddComponent,
        StepsAddComponent,
        StepsEditComponent,
        WorkProceduresEditComponent,
        FamiliesSubscribersAddComponent,
        ProductSubscribersComponent,
        ProductSubscribersAddComponent,
        ProductFeaturesComponent,
        ProductCostsComponent,
        ProductPricePurchaseComponent,
        ProductWarehousesComponent,
        ProductPricesComponent,
        ProductStockComponent,
        ProductLocatedStockComponent,
        ProductSeasonalitiesComponent,
        ProductDocumentPendingBatchComponent,
        ProductBatchTechnicalFeaturesComponent,
        ProductBatchExpensesComponent,
        ProductBatchMovementsComponent,
        ProductsProcessSheetsAddComponent,
        ProcessSheetsProductAddComponent,
        ProcessSheetOperationsComponent,
        RoutingAddComponent,
        RoutingOperationsAddComponent,
        RoutingOperationsEditComponent,
        ResourceAllocationAddComponent,
        ProcessSheetMaterialsComponent,
        ProcessSheetOverheadsComponent,
        ProcessSheetOverheadsAddComponent,
        ProcessSheetsBomAddComponent,
        WorkProcedureEditComponent,
        ProductProcesSheetsComponent,
        ProcessSheetMaterialsAddComponent,
        ProductSimulationsComponent,
        SimulationsComponent,
        ProcessSheetLinksComponent,
        WorkProcedureLinksComponent,
        ProductMapComponent,
        ProductAncestorsDescendantsComponent,
    ],
    exports: [
        ProductMapComponent
    ],
    imports: [
        ProductsRoutingModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        UserRoutingModule,
        DxPopupModule,
        DxLookupModule,
        DxSelectBoxModule,
        DxSchedulerModule,
        DxTextBoxModule,
        DxDateBoxModule,
        DxDataGridModule,
        DxScrollViewModule,
        DxDropDownButtonModule,
        DxProgressBarModule,
        DxSortableModule,
        DxDropDownBoxModule,
        DxCheckBoxModule,
        DxColorBoxModule,
        DxTabsModule,
        DxToolbarModule,
        DxNumberBoxModule,
        DxDrawerModule,
        DxTabPanelModule,
        DxListModule,
        DxTextAreaModule,
        DxSwitchModule,
        DxValidatorModule,
        DxLoadPanelModule,
        DxButtonModule,
        DxTagBoxModule,
        DxTreeListModule,
        NgPipesModule,
        TranslateModule,
        GSModule,
        QRCodeComponent,
        DxTooltipModule,
        GsPopupComponent,
    ]
})
export class ProductsModule { }
